export default "__VITE_ASSET__CZ3srNhT__"